import { LlavesAuthConfig } from "./Llaves/RepositorioConfig";
import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        clientId: LlavesAuthConfig.auth.clientId,
        authority: LlavesAuthConfig.auth.authority,
        redirectUri: LlavesAuthConfig.auth.redirectUri
    },
    cache: {
        cacheLocation: LlavesAuthConfig.cache.cacheLocation, // This configures where your cache will be stored
        storeAuthStateInCookie: LlavesAuthConfig.cache.storeAuthStateInCookie, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {		
                    case LogLevel.Error:		
                        console.error(message);		
                        return;		
                    case LogLevel.Info:		
                        console.info(message);		
                        return;		
                    case LogLevel.Verbose:		
                        console.debug(message);		
                        return;		
                    case LogLevel.Warning:		
                        console.warn(message);		
                        return;		
                }	
            }	
        }	
    }
};

export const loginRequest = {
    scopes: LlavesAuthConfig.loginRequest.scopes,
    redirectUri: LlavesAuthConfig.loginRequest.redirectUri
};

export const graphConfig = {
    graphMeEndpoint: LlavesAuthConfig.graphConfig.graphMeEndpoint
};
